import api from '@/services/api';

const CompanyContractTagQuery = {
  getCompanyContractTagList: () => {
    return api.get('get_company_contract_tag_list/');
  },
  getAllCompanyContractTag: () => {
    return api.get('get_all_company_contract_tag/');
  }
};

export default CompanyContractTagQuery;



// WEBPACK FOOTER //
// ./src/api/tag/query.js